// extracted by mini-css-extract-plugin
export default {"root":"_2ifti","message":"_8FYl2","button":"_3C2_2"};